import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { ScrollView } from 'react-native';
import Spinner from '@dbk/ui-spinner';
// import ScrollToBottom from 'react-scroll-to-bottom';
import AttachmentIcon from '../../common/icons/attachment-icon';
import SentMessage from './sent-message';
import ReceivedMessage from './received-message';
import ChatTextInput from './chatTextInput';
import { CHAT_MSG_TYPE, CHAT_RECIPIENT_TYPE, DOCUPLOAD_FILE_RULES } from '../../../../src/constants';
import download from '../../../../src/muster/utils/downloader';
import { NotificationWarning } from '@dbk/ui-icons';

class Messenger extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
      showSpinnerOnUpload: false
    };
  }

  componentWillMount() {
    const { toUserId } = this.props;
    const pageNumber = 0;
    this.props.fetchChatHistory({ toUserId, pageNumber });
  }

  componentWillUnmount() {
    this.props.setChatHistory([]);
  }
  scrollViewToBottom = () => {
    if (this.rootView) {
      this.rootView.scrollToEnd({ animated: false });
    }
  }

  onAttachmentClick = () => {
    if (this.fileInput) {
      this.fileInput.click();
    }
  }


  fileChangeHandler = (event) => {
    const fileList = event.target.files;
    for (let i = 0; i < fileList.length; i++) {
      this.onload(fileList[i]);
    }
  }

  /**
   * method to check file extension
   */
  validFileType = (file) => {
    const fileTypes = ['jpeg', 'png', 'pdf', 'jpg']; 
    var extension = file.name.split('.').pop().toLowerCase(),  //file extension from input file
    isSuccess = fileTypes.indexOf(extension) > -1;  
    return isSuccess;
  }

  onload = (file) => {
    const {
      i18n: { messages } } = this.props;
    let isValidFileType = this.validFileType(file);
    if(!isValidFileType) {
      this.props.setChatError(messages['app.chat.fileTypeError']);
      return;
    }
    const readerFile = new FileReader();
    const that = this;
    readerFile.onloadend = function () {
      // console.log('RESULT', readerFile.result)
      that.uploadAttachment(readerFile.result, file);

    }
    // readerFile.onloadend = function (loadEvent) {
    //   const arrayBuffer = loadEvent.target.result;
    //   const buffer = event.target.result;
    //   console.log(buffer.byteLength);


    // }
    readerFile.readAsDataURL(file);
  }

  /**
   * method to upload attachemnt
   */
  uploadAttachment = (base64Data, file) => {
    this.setState({ showSpinnerOnUpload: true })
    const {
      settings: { currentEnvironment: { remoteUrl } },
      app: { config: { apiverion } },
      auth: { userId, authHeader },
      chat: { toUserActive },
      i18n: { messages } } = this.props;

    let body = {};
    let validFilesize = file.size < DOCUPLOAD_FILE_RULES.maxSize;
    let base64SplittedData = base64Data.split(',')[1];

    if (base64SplittedData && base64SplittedData !== null && base64SplittedData !== '' &&  validFilesize) {
      // if (validFilesize) {


        body = {
          data: base64SplittedData,
          contentType: file.type,
          fileName: file.name,
          fromUserId: userId,
          toUserId: toUserActive.userId
        }

        // const url = "https://uat1.deutschewealthonline.intranet.db.com/ebanking";
        const uploadUrl =  remoteUrl + '/chatservices/' + apiverion + '/uploadBase64';
        const x = new XMLHttpRequest();
        const fileName = body.fileName;
        x.open('POST', uploadUrl, true);
        x.setRequestHeader('Authorization-Token', authHeader);

         //For testing on local environment
        // x.setRequestHeader('Authorization', 'Bearer 902a830f670530f503e5e79451cb5906');
        x.setRequestHeader('content-type', 'application/json; charset=utf-8');



        x.ontimeout = function () {

          this.props.setChatError(messages['app.marque.unExpectederror'])
          this.props.setChatIsDownloading(false);
          this.setState({ showSpinnerOnUpload: false });
        }
        x.onload = async (e) => {
          try {

            if (x.status === 200) {
              const jsonResponse = JSON.parse(x.responseText);

              const messageObj = {
                "fromUserId": this.props.auth.userId,
                "toUserId": this.props.chat.toUserActive.userId,
                "msgType": CHAT_MSG_TYPE.CHAT_MSG,
                "chatType": CHAT_RECIPIENT_TYPE.INDIVIDUAL,
                "message": fileName,
                "meta": null,
                "attachmentId": jsonResponse.attachmentId
              }
              this.props.message(messageObj)
              this.setState({ showSpinnerOnUpload: false });
            }
            else {
              this.props.setChatError(messages['app.marque.unExpectederror'])
              this.props.setChatIsDownloading(false);
              this.setState({ showSpinnerOnUpload: false });
            }
          }
          catch (error) {
            this.props.setChatError(messages['app.marque.unExpectederror'])
            this.props.setChatIsDownloading(false);
            this.setState({ showSpinnerOnUpload: false });
          }
        };
        x.onerror = () => {

          const messageObj = {
            "fromUserId": this.props.auth.userId,
            "toUserId": this.props.chat.toUserActive.userId,
            "msgType": CHAT_MSG_TYPE.CHAT_MSG,
            "chatType": CHAT_RECIPIENT_TYPE.INDIVIDUAL,
            "message": fileName,
            "meta": null,
            "attachmentId": '123456'
          }
          this.props.message(messageObj);
          this.props.setChatError(messages['app.marque.unExpectederror'])
          this.props.setChatIsDownloading(false);
          this.setState({ showSpinnerOnUpload: false });
        }
        x.send(JSON.stringify(body));
      // } 
      // else {
      //   
      // }
    }
    else {
      this.setState({ showSpinnerOnUpload: false });
      validFilesize ? alert(messages["app.common.invalidData"]) : alert(messages['app.docsigncenter.uploadDoc.fileTooBig']);
    }
  }


  /**
   * method to download attachment
   */
  downloadAttachment = (message, callback) => {

    const { app: { config: { apiverion } },
      settings: { currentEnvironment: { remoteUrl } },
      auth: { userId, authHeader },
      i18n: { messages } } = this.props;

    const that = this;


    const downloadUrl = remoteUrl + '/chatservices/' + apiverion + '/downloadBase64';
    // const downloadUrl = 'http://10.2.231.160:18118/downloadBase64';
    // const downloadUrl = 'https://uat1.deutschewealthonline.intranet.db.com/ebanking/chatservices/' + apiverion + '/downloadBase64';
    const body = {
      attachmentId: message.attachmentId,
      userId
    }

    const x = new XMLHttpRequest();

    x.open('POST', downloadUrl, true);
    x.setRequestHeader('Authorization-Token', authHeader);
    x.setRequestHeader('content-type', 'application/json');
    x.setRequestHeader('Accept', 'application/octet-stream');

    // For testing on local environment
    // x.setRequestHeader('Authorization', 'Bearer 902a830f670530f503e5e79451cb5906');

    x.setRequestHeader(
      'Content-Disposition',
      'inline; filename=' + message.attachmentId
    );
    x.setRequestHeader(
      'Cache-Control',
      'no-cache, no-store, must-revalidate'
    );

    x.ontimeout = function () {
      this.props.setChatError(messages['app.marque.unExpectederror']);
      callback();
    }

    x.onload = async (e) => {
      try {
        if (x.status === 200) {
          // downloading file
          download(that.base64ToArrayBuffer(JSON.parse(x.response).data),
            JSON.parse(x.response).fileName, JSON.parse(x.response).contentType);
        }
        else {
          callback();
          this.props.setChatError(messages['app.marque.unExpectederror']);
        }
      }
      catch (error) {
        this.props.setChatError(messages['app.marque.unExpectederror']);
      }
      callback();
    }
    x.onerror = (e) => {
      this.props.setChatError(messages['app.marque.unExpectederror']);
      callback();
    };
    x.send(JSON.stringify(body));
  }

  base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  }

  /**
   * method to handle input text
   */
  onTextKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();

      this.setState({
        text: event.target.value
      }, () => {
        if (this.state.text.trim().length !== 0) {
          this
            .props
            .message(this.state.text);
          this.setState({ text: '' });

        }
      })
    }
  }

  render() {
    const { chatHistory, auth: { userId }, app: { config: { chat: { enableAttachment } } }, i18n: { messages } } = this.props;
    return (
      <div className="bar">

        {chatHistory.length === 0 && <div className="center-content pad-top-15 height-100"><Spinner /></div>}
        {chatHistory.length !== 0 &&
          <ScrollView
            className="chat-screen"
            onContentSizeChange={() => this.scrollViewToBottom()}
            ref={(rootView) => { this.rootView = rootView }}
          >
            <div className="messenger-container bar">
              <div className=" messages row">
                {this.state.showSpinnerOnUpload && <div className="chat-detail-spinner"> <Spinner /> </div>}
                {!this.state.showSpinnerOnUpload && <div className="columns">
                <div className="warning-message-container">
                <NotificationWarning color="color:#000E28;" className="warning-icon" width={20} height={20}/>
                <span className="warning-message-content">{messages["app.chat.compliance"]}</span>
                  </div>
                  {chatHistory.map((message) => (message.fromUserId === userId ?
                    <SentMessage
                      message={message}
                      downloadAttachment={this.downloadAttachment}
                    />
                    :
                    <ReceivedMessage
                      message={message}
                      downloadAttachment={this.downloadAttachment}
                    />
                  ))}
                </div>}

              </div>
            </div>
          </ScrollView>

        }


        <div className="send-message">
          <input type="file" className="hide"
            onChange={this.fileChangeHandler}
            ref={(fi) => { this.fileInput = fi }}
          />
          {enableAttachment && <AttachmentIcon onClick={this.onAttachmentClick}
            className="attachment-file curser-pointer" width={25} height={25} />}
          <ChatTextInput value={this.state.text} onTextKeyPress={this.onTextKeyPress} isAttachmentEnabled={enableAttachment} />
        </div>
      </div>
    );
  }
}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    app: {
      config: {
        apiverion: true,
        chat: {
          enableAttachment: true
        }
      }
    },
    setChatIsDownloading: {
      $set: 'chat.isDownloading'
    },
    setChatError: {
      $set: 'chat.chatError'
    },
    chat: {
      toUserActive: true,
      webSocket: true
    },
    auth: {
      userId: true,
      authHeader: true,
      langCode: true
    },
    settings: {
      currentEnvironment: {
        remoteUrl: true,
      },
    },
    setChatHistory: { $set: 'chat.chatHistory' }
  }
})(Messenger);
